function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_dashboard_a{fill:#fff;stroke:#707070;}\n      .icon_menu_dashboard_b{clip-path:url(#icon_menu_dashboard_a);}\n      .icon_menu_dashboard_c{fill:#ffc107;}\n      .icon_menu_dashboard_d{fill:#dea806;}\n      .icon_menu_dashboard_e{fill:#4caf50;}\n      .icon_menu_dashboard_f{fill:#429846;}\n      .icon_menu_dashboard_g{fill:#2196f3;}\n      .icon_menu_dashboard_h{fill:#1d83d4;}\n    "), React.createElement("clipPath", {
  id: "icon_menu_dashboard_a"
}, React.createElement("rect", {
  className: "icon_menu_dashboard_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1048)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_dashboard_b",
  transform: "translate(-1800 -1048)"
}, React.createElement("g", {
  transform: "translate(1800 1048)"
}, React.createElement("path", {
  className: "icon_menu_dashboard_c",
  d: "M8.313,7.719V.594A.594.594,0,0,0,7.719,0,7.728,7.728,0,0,0,0,7.719a.594.594,0,0,0,.594.594H7.719A.594.594,0,0,0,8.313,7.719Z"
}), React.createElement("path", {
  className: "icon_menu_dashboard_d",
  d: "M2.226,2.3A7.691,7.691,0,0,0,0,7.719a.594.594,0,0,0,.594.594H7.719a.593.593,0,0,0,.419-.173Z"
}), React.createElement("path", {
  className: "icon_menu_dashboard_e",
  d: "M9.145,11.022a.594.594,0,0,0-.534-.334H1.437a.594.594,0,0,0-.594.594,7.781,7.781,0,0,0,11.141,6.956.594.594,0,0,0,.279-.8Z"
}), React.createElement("path", {
  className: "icon_menu_dashboard_f",
  d: "M8.61,10.688H1.437a.594.594,0,0,0-.594.594A7.712,7.712,0,0,0,4.619,17.9l4.326-7.11A.6.6,0,0,0,8.61,10.688Z"
}), React.createElement("path", {
  className: "icon_menu_dashboard_g",
  d: "M11.281,1.409A.594.594,0,0,0,10.688,2V9.082a.6.6,0,0,0,.059.259l3.1,6.379a.593.593,0,0,0,.534.335A.587.587,0,0,0,14.636,16,7.625,7.625,0,0,0,19,9.083a7.7,7.7,0,0,0-7.719-7.674Z"
}), React.createElement("path", {
  className: "icon_menu_dashboard_h",
  d: "M18.742,7.112,10.717,9.266a.62.62,0,0,0,.03.075l3.1,6.379a.593.593,0,0,0,.534.335A.587.587,0,0,0,14.636,16a7.658,7.658,0,0,0,4.106-8.885Z"
})));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.eaba7ed2.svg";
export { ForwardRef as ReactComponent };